import { create } from 'zustand'
import type { Attribute, AttributeFormData } from '@/types/attribute'

interface AttributesState {
  attributes: Attribute[]
  setAttributes: (attributes: Attribute[]) => void
  addAttribute: (data: AttributeFormData) => void
  updateAttribute: (id: string, data: AttributeFormData) => void
  deleteAttribute: (id: string) => void
}

let nextId = 1

export const useAttributesStore = create<AttributesState>(set => ({
  attributes: [],

  setAttributes: attributes => {
    nextId = Math.max(
      attributes.length + 1,
      ...attributes
        .map(attribute => Number(attribute.id))
        .filter(id => Number.isFinite(id))
        .map(id => id + 1),
      1
    )

    set({ attributes })
  },

  addAttribute: data => {
    const newAttribute: Attribute = {
      id: String(nextId++),
      ...data,
      created_at: new Date().toISOString(),
    }
    set(state => ({ attributes: [newAttribute, ...state.attributes] }))
  },

  updateAttribute: (id, data) => {
    set(state => ({
      attributes: state.attributes.map(attr =>
        attr.id === id ? { ...attr, ...data } : attr
      ),
    }))
  },

  deleteAttribute: id => {
    set(state => ({
      attributes: state.attributes.filter(attr => attr.id !== id),
    }))
  },
}))
